<template>
    <div>
        <vSelect :options="scheduleTypeOptions" v-model="scheduleTypeId" :disabled="disabled" :reduce="option => option.id" label="name"/>
    </div>
</template>

<script>
import scheduledTask from '@/store/system/scheduledTask'
import vSelect from 'vue-select'

export default {
    name: 'ScheduleTypeSelect',
    components: {
        vSelect
    },
    props: {
        value: String,
        disabled: Boolean
    },
    computed: {
        scheduleTypeOptions: function() {
            var optionList = [];
            for (var scheduleType of this.$store.state.scheduledTask.scheduleTypeList) {
                optionList.push({ id: scheduleType, name: this.$t('scheduled_tasks.schedule.'+ scheduleType) })
            }
            return optionList;
        },
        scheduleTypeId: {
            get: function() { return this.value },
            set: function(newValue) {
                this.$emit('input', newValue);
            }
        }
    },
    created() {
        if (!this.$store.state.scheduledTask) {
            this.$store.registerModule('scheduledTask', scheduledTask);
        }
        this.$store.dispatch('scheduledTask/getScheduleTypeList');
    }
}
</script>

<style lang="scss">
    @import 'vue-select/src/scss/vue-select.scss';
</style>